import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiButton, UiIcon, UiMenuItem, UiSelect } from 'ui-components';
import { SORT_ORDER, USER_SORT_OPTIONS } from '../../constants/userListFilters';
import { StyledUsersSort } from './UsersSort.styles';

function UsersSort({ field = '', order = SORT_ORDER.DESC, onChange }) {
  const { t } = useTranslation();
  const isAsc = order === SORT_ORDER.ASC;

  const handleFieldChange = (event) => {
    const nextField = event.target.value;
    onChange({
      field: nextField,
      order: nextField ? order : SORT_ORDER.DESC,
    });
  };

  const handleOrderToggle = () => {
    if (!field) return;
    onChange({
      field,
      order: isAsc ? SORT_ORDER.DESC : SORT_ORDER.ASC,
    });
  };

  const renderFieldValue = (selected) =>
    selected ? (
      t(`users:sort.${selected}`)
    ) : (
      <span className='placeholder'>{t('users:sort.placeholder')}</span>
    );

  return (
    <StyledUsersSort>
      <div className='sort-field'>
        <UiSelect
          displayEmpty
          value={field}
          onChange={handleFieldChange}
          renderValue={renderFieldValue}
        >
          <UiMenuItem value=''>{t('users:sort.default')}</UiMenuItem>
          {USER_SORT_OPTIONS.map((value) => (
            <UiMenuItem key={value} value={value}>
              {t(`users:sort.${value}`)}
            </UiMenuItem>
          ))}
        </UiSelect>
      </div>
      <UiButton
        className='sort-order-btn'
        variant='outlined'
        color='primary'
        disabled={!field}
        onClick={handleOrderToggle}
        title={t(isAsc ? 'users:sort.ascending' : 'users:sort.descending')}
      >
        <UiIcon icon={isAsc ? 'ri-sort-asc' : 'ri-sort-desc'} size={18} />
      </UiButton>
    </StyledUsersSort>
  );
}

UsersSort.propTypes = {
  field: PropTypes.string,
  order: PropTypes.oneOf([SORT_ORDER.ASC, SORT_ORDER.DESC]),
  onChange: PropTypes.func.isRequired,
};

export default UsersSort;
